<template>
  <div class="sensors-view">
    <v-container>
      <v-row>
        <v-col cols="12">
          <h1>Sensors</h1>
          <p>Gestión de sensores del sistema</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="sensorsList"
            :loading="loading"
            class="elevation-1"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Lista de Sensores</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="refreshData">
                  <v-icon left>mdi-refresh</v-icon>
                  Actualizar
                </v-btn>
                <v-btn color="success" class="ml-2" @click="addItem">
                  <v-icon left>mdi-plus</v-icon>
                  Agregar Sensor
                </v-btn>
              </v-toolbar>
            </template>
            <template v-slot:item.color="{ item }">
              <v-chip 
                :style="{ backgroundColor: item.color, color: getContrastColor(item.color) }" 
                small
              >
                {{ item.color }}
              </v-chip>
            </template>
            <template v-slot:item.field="{ item }">
              <v-chip color="blue" variant="outlined" small>
                {{ item.field }}
              </v-chip>
            </template>
            <template v-slot:item.type="{ item }">
              <v-chip color="purple" variant="outlined" small>
                {{ item.type }}
              </v-chip>
            </template>
            <template v-slot:item.unit="{ item }">
              <span class="font-weight-medium">{{ item.unit }}</span>
            </template>
            <template v-slot:item.createdAt="{ item }">
              {{ formatDate(item.createdAt) }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)">
                mdi-pencil
              </v-icon>
              <v-icon small @click="deleteItem(item)">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from 'vue'
import { useSensorStore } from './store'
import { Sensor } from './models/sensor'

const sensorStore = useSensorStore()
const loading = ref(false)

const headers = [
  { title: 'ID', key: 'id' },
  { title: 'Campo', key: 'field' },
  { title: 'Nombre', key: 'name' },
  { title: 'Unidad', key: 'unit' },
  { title: 'Color', key: 'color' },
  { title: 'Tipo', key: 'type' },
  { title: 'Creado', key: 'createdAt' },
  { title: 'Creado por', key: 'createdBy' },
  { title: 'Acciones', key: 'actions', sortable: false },
]

const sensorsList = computed(() => sensorStore.sensors)

const formatDate = (date: Date | string) => {
  return new Date(date).toLocaleDateString('es-ES')
}

const getContrastColor = (hexColor: string) => {
  // Función para determinar si usar texto blanco o negro según el color de fondo
  if (!hexColor || hexColor === '') return '#000000'
  
  // Remover el # si existe
  const color = hexColor.replace('#', '')
  
  // Convertir a RGB
  const r = parseInt(color.substring(0, 2), 16)
  const g = parseInt(color.substring(2, 4), 16)
  const b = parseInt(color.substring(4, 6), 16)
  
  // Calcular luminancia
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255
  
  return luminance > 0.5 ? '#000000' : '#ffffff'
}

const refreshData = async () => {
  loading.value = true
  try {
    await sensorStore.getSensors()
  } finally {
    loading.value = false
  }
}

const addItem = () => {
  // Implementar lógica para agregar sensor
  console.log('Add new sensor')
}

const editItem = (item: Sensor) => {
  // Implementar lógica de edición
  console.log('Edit item:', item)
}

const deleteItem = (item: Sensor) => {
  // Implementar lógica de eliminación
  console.log('Delete item:', item)
}

onMounted(() => {
  refreshData()
})
</script>

<style scoped>
.sensors-view {
  height: 100%;
}
</style>
